import React from 'react';
import DemandeDetailsPage from './DemandeDetailsPage';

const DemandeDetails = () => {
  return (
    <div>
      <DemandeDetailsPage />
    </div>
  );
};

export default DemandeDetails;